import { useEffect, useRef, useState } from "react";
import classes from "./NextGen.module.css";

const traderList = [
  {
    image: "/images/currency.svg",
    title: "Zero Swaps & Commissions",
    subTitle: "Trade freely with no extra costs or deductions",
  },
  {
    image: "/images/pie-chart.svg",
    title: "Community Pool",
    subTitle: "50% of fees fund trader payouts",
  },
  {
    image: "/images/money.svg",
    title: "Take home 100% of payouts",
    subTitle: "Your hard work, your profits—take home everything",
  },
  {
    image: "/images/prop-cover.svg",
    title: "Propcover",
    subTitle: "Get reimbursed if you lose your funded account. Terms apply*",
  },
  {
    image: "/images/coin-percentage.svg",
    title: "Community Airdrops",
    subTitle:
      "10% of pool profits are redistributed each year to funded traders",
  },
];

const NextGen = () => {
    const scrollRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  // Track current scroll position
   const handleScroll = () => {
    const scroller = scrollRef.current;
    if (!scroller) return;

    const scrollLeft = scroller.scrollLeft;
    const totalScrollWidth = scroller.scrollWidth - scroller.clientWidth;
    const scrollRatio = scrollLeft / totalScrollWidth;

    const index = Math.round(scrollRatio * (traderList.length - 1));
    setActiveIndex(index);
  };

  useEffect(() => {
    const scroller = scrollRef.current;
    if (scroller) {
      scroller.addEventListener("scroll", handleScroll);
      return () => scroller.removeEventListener("scroll", handleScroll);
    }
  }, []);
  
  return (
        
      <div >
        {/* Desktop Grid */}
        <div className={`row mt-sm-2 d-none d-md-flex`}>
          {traderList.map((item, i) => {
            const isWide = i === 3 || i === 4;
            return (
              <div
                className={`col-md-${isWide ? "6" : "4"} ${
                  isWide ? "mt-4" : ""
                } ${i === 1 ? "d-flex justify-content-center" : ""}`}
                key={i}
              >
                <div
                  className={`${classes.card} ${i === 0 ? "float-end" : ""}`}
                >
                  <div
                    className={`${classes.imageContainer} d-flex justify-content-center align-items-center`}
                  >
                    <img src={item.image} />
                  </div>
                  <h5>{item.title}</h5>
                  <h6>{item.subTitle}</h6>
                </div>
              </div>
            );
          })}
        </div>

        {/* Mobile Horizontal Scroll */}
        <div className={`d-block d-md-none ${classes.mobileScrollWrapper}`}>
          <div className={classes.scrollContainer} ref={scrollRef}>
            {traderList.map((item, i) => (
              <div className={classes.scrollItem} key={i}>
                <div className={classes.card}>
                  <div
                    className={`${classes.imageContainer} d-flex justify-content-center align-items-center`}
                  >
                    <img src={item.image} />
                  </div>
                  <h5>{item.title}</h5>
                  <h6>{item.subTitle}</h6>
                </div>
              </div>
            ))}
          </div>

          {/* Dots */}
          <div className={classes.dots}>
            {traderList.map((_, i) => (
              <span
                key={i}
                className={`${classes.dot} ${
                  i === activeIndex ? classes.activeDot : ""
                }`}
              ></span>
            ))}
          </div>
        </div>
      </div>
  );
};

export default NextGen;
